import Tooltip from "../../../../common/StyledToolTip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Menu, MenuItem } from "@material-ui/core";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import constants from "./constants";
import { getStopHeaderText } from "./EditStopDialog/util";
const StopActionMenu = ({
  anchorEl,
  handleMenuClose,
  isMarkAsNextStopEnabled,
  isPickupStop,
  handleMenuChange,
  classes,
  enableRemovePro,
  enableAddNotesToPro,
  enableAddProToCompletedPro,
  isCompletedStop,
  isNoFreight,
  isBobTailRoute,
  enableReprocessDelivery,
  enableRevisitDeliveryStop,
  isStopAlreadyRevisited,
  isSplitStop,
  shouldDisableActionForPreDispatch = false
}) => {
  /* Add pro notes will be enabled in following cases:
    1. Completed stops(Excluding no freight pickup stops)
    2. Pending Delivery stops
    3. No Freight pickup
  */
  const isEnabledAddProNotes = !isNoFreight && (isCompletedStop || !isPickupStop);
  const isEnabledAddProToCompletedPro = !isNoFreight && isCompletedStop;
  const getPickupTooltipText = () => {
    if (isBobTailRoute) {
      return 'Hook trailer before processing pickup';
    } else if (isCompletedStop) {
      return "Cannot process completed pickup"
    } else if (shouldDisableActionForPreDispatch) {
      return "Prossess pickup (disabled)";
    }
    return '';
  }
  const getAddProNotesTooltip = () => {
    if (isEnabledAddProNotes) {
      if (shouldDisableActionForPreDispatch) {
        return "Add Notes to Pro (disabled)";
      }
      return "Add Notes to Pro"
    }
    return "Complete pickup with pros to enable";
  }
  const getRevisitStopTooltip = () => {
    if (isStopAlreadyRevisited) {
      return "Stop already revisited";
    } else if (isSplitStop) {
      return "Revisit not available for split stops";
    } else if (!enableRevisitDeliveryStop || shouldDisableActionForPreDispatch) {
      return "Revisit stop (disabled)";
    }
    return "";
  }
  const getMarkAsNextStopTooltip = () => {
    if (!isMarkAsNextStopEnabled || isCompletedStop || shouldDisableActionForPreDispatch) {
      return "Mark as next stop (disabled)";
    }
    return "Driver will be notified to go to this stop next";
  }
  const getAddProToPickupTooltip = () => {
    if (!isEnabledAddProToCompletedPro || shouldDisableActionForPreDispatch) {
      return "Add Pro to Pickup (disabled)";
    }
    return "Add Pro to Pickup";
  }
  return (
    <Menu
      classes={{
        paper: classes.menu,
      }}
      id="stops-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      MenuListProps={{
        "aria-labelledby": "edit",
        disablePadding: true,
      }}
      getContentAnchorEl={null}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      {enableAddNotesToPro && (
        <Tooltip
          title={getAddProNotesTooltip()}
          disableFocusListener
        >
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() =>
                handleMenuChange(constants.STOPS_MENU_ACTION_LIST.ADD_PRO_NOTES)
              }
              disabled={!isEnabledAddProNotes || shouldDisableActionForPreDispatch}
            >
              Add Notes to Pro
            </MenuItem>
          </div>
        </Tooltip>
      )}
      {!isPickupStop && (
        <MenuItem
          className={classes.menuItem}
          disabled={isCompletedStop ? !enableReprocessDelivery : false || shouldDisableActionForPreDispatch}
          onClick={() =>
            handleMenuChange(constants.STOPS_MENU_ACTION_LIST.PROCESS_DELIVERY)
          }
        >
          {getStopHeaderText(isCompletedStop)}
        </MenuItem>
      )}
      {!isPickupStop &&
        <Tooltip title={getRevisitStopTooltip()}>
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() => handleMenuChange(constants.STOPS_MENU_ACTION_LIST.REVISIT_STOP)}
              disabled={!enableRevisitDeliveryStop || isStopAlreadyRevisited || isSplitStop || shouldDisableActionForPreDispatch}>
              Revisit stop
            </MenuItem>
          </div>
        </Tooltip>
      }
      {isPickupStop && (
        <Tooltip
          title={getPickupTooltipText()}
          disableFocusListener>
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() => handleMenuChange(constants.STOPS_MENU_ACTION_LIST.PROCESS_PICKUP)}
              disabled={isCompletedStop || isBobTailRoute || shouldDisableActionForPreDispatch}>
              Process a pickup
            </MenuItem>
          </div>
        </Tooltip>
      )}
      {!isPickupStop && (
        <MenuItem
          className={classes.menuItem}
          disabled={!enableRemovePro || isCompletedStop}
          onClick={() =>
            handleMenuChange(constants.STOPS_MENU_ACTION_LIST.REMOVE_PRO)
          }
        >
          Remove pro
        </MenuItem>
      )}
      <Tooltip
        title={getMarkAsNextStopTooltip()}
        disableFocusListener
      >
        <div>
          <MenuItem
            disabled={!isMarkAsNextStopEnabled || isCompletedStop || shouldDisableActionForPreDispatch}
            className={classes.menuItem}
            onClick={() =>
              handleMenuChange(
                constants.STOPS_MENU_ACTION_LIST.MARK_AS_NEXT_STOP
              )
            }
          >
            <span className={classes.markNextStopAction}>
              Mark as next stop
              <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
            </span>
          </MenuItem>
        </div>
      </Tooltip>
      {(enableAddProToCompletedPro && isPickupStop) && (
        <Tooltip title={getAddProToPickupTooltip()}>
          <div>
            <MenuItem
              className={classes.menuItem}
              onClick={() =>
                handleMenuChange(constants.STOPS_MENU_ACTION_LIST.ADD_PRO_TO_PICKUP)
              }
              disabled={!isEnabledAddProToCompletedPro || shouldDisableActionForPreDispatch}
            >
              Add Pro to Pickup
            </MenuItem>
          </div>
        </Tooltip>
      )}
    </Menu>
  );
};

export default withStyles(styles)(StopActionMenu);
